import { api } from "./api";

export interface UpdateCustomerParams {
  email?: string;
  name?: string;
}

export interface Customer {
  id: string;
  name: string;
  email: string;
  phone: string;
  // Adicione outros campos conforme necessário
}

async function updateCustomer(
  id: string,
  data: UpdateCustomerParams,
): Promise<Customer> {
  const response = await api.put<{ data: Customer }>(
    `/v1/customers/${id}`,
    data,
  );
  return response.data.data;
}

export const CustomersService = {
  updateCustomer,
};
